import { takeLatest, putResolve } from 'redux-saga/effects';
import { updatePath } from '../actions/pathActions';
import safeSaga from './safeSaga';

function* addStepsToPath() {
  yield putResolve(updatePath());
}

export function* postAddStepsSaga() {
  yield takeLatest('UPDATE_STEPS', safeSaga(addStepsToPath));
}
